/** The most columns a board may have: the API's MAX_COLUMNS (apps/api/src/columnOrder.ts), which refuses more. */
export const MAX_COLUMNS = 15;
